import { render, staticRenderFns } from "./electronicbilldetailed.vue?vue&type=template&id=35d7ce87"
import script from "./electronicbilldetailed.vue?vue&type=script&lang=js"
export * from "./electronicbilldetailed.vue?vue&type=script&lang=js"
import style0 from "./electronicbilldetailed.vue?vue&type=style&index=0&id=35d7ce87&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports